__turbopack_context__.v({
  "container": "styles-module-scss-module__p17PLa__container",
  "quoteIcon": "styles-module-scss-module__p17PLa__quoteIcon",
  "role": "styles-module-scss-module__p17PLa__role",
  "testimonial": "styles-module-scss-module__p17PLa__testimonial",
});
